import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { FormsBuilderPolishedRoutingModule } from './forms-builder-polished-routing.module';
import { FormsBuilderPolishedComponent } from './forms-builder-polished.component';
import { FormsBuilderPolishedItemComponent } from './forms-builder-polished-item/forms-builder-polished-item.component';
import { FormsGlobals } from '../../../models/forms/forms.enum';
import { FormsBuilderPolishedConfirmComponent } from './forms-builder-polished-confirm/forms-builder-polished-confirm.component';
import { FormsBuilderPolishedPreviewComponent } from './forms-builder-polished-preview/forms-builder-polished-preview.component';

import { MatRadioModule } from '@angular/material/radio';
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSliderModule } from '@angular/material/slider';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { FormsFormModule } from '../forms-form/forms-form.module';
import { FormsBuilderPolishedFormCreationComponent } from './forms-builder-polished-form-creation/forms-builder-polished-form-creation.component';
import {TdoControlsModule} from '../../../tdo-controls/tdo-controls.module';
import {MatIconModule} from '@angular/material/icon';



@NgModule({
  declarations: [
    FormsBuilderPolishedComponent,
    FormsBuilderPolishedItemComponent,
    FormsBuilderPolishedConfirmComponent,
    FormsBuilderPolishedPreviewComponent,
    FormsBuilderPolishedFormCreationComponent
  ],
    imports: [
        CommonModule,
        FormsModule,
        FormsBuilderPolishedRoutingModule,
        FormsFormModule,

        MatRadioModule,
        MatCheckboxModule,
        MatSliderModule,
        MatSelectModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatDatepickerModule,
        MatDividerModule,
        MatProgressSpinnerModule,
        MatTooltipModule,
        MatDialogModule,
        MatSnackBarModule,
        DragDropModule,
        TdoControlsModule,
        MatIconModule,
    ],
  exports: [
    FormsBuilderPolishedComponent
  ],
  providers: [
    FormsGlobals
  ]
})
export class FormsBuilderPolishedModule { }



